var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-navigation-drawer",
        {
          staticClass: "nav-drawer",
          class: { hidden: !_vm.authenticated },
          attrs: { right: "", absolute: "", dense: "", width: "330" },
          model: {
            value: _vm.rightDrawer,
            callback: function ($$v) {
              _vm.rightDrawer = $$v
            },
            expression: "rightDrawer",
          },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "mx-auto",
              staticStyle: { height: "100%" },
              attrs: { "max-width": "400" },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-center pt-5 pb-3" },
                [
                  _c(
                    "v-avatar",
                    { attrs: { color: "blue", size: "70" } },
                    [
                      _c("v-gravatar", {
                        staticClass: "gravatar-img position-absolute",
                        staticStyle: { "z-index": "2" },
                        attrs: {
                          email: _vm.user.email,
                          alt: _vm.user.fullName,
                          size: 48,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-center" }, [
                _c("span", { staticClass: "subtitle-1" }, [
                  _c("strong", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.user.fullName) +
                        "\n          "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { path: "/account/settings" } } },
                    [
                      _c("span", { staticClass: "subtitle-2" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.menu.account.settings")) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list",
                { attrs: { dense: "" } },
                [
                  _vm.userCompanies.length
                    ? _c("v-divider", { staticClass: "my-3" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userCompanies.length
                    ? _c("v-subheader", { staticClass: "primary--text" }, [
                        _vm._v("COMPANIES"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userCompanies
                    ? _c(
                        "v-list-item-group",
                        {
                          attrs: { color: "primary" },
                          model: {
                            value: _vm.activeCompany,
                            callback: function ($$v) {
                              _vm.activeCompany = $$v
                            },
                            expression: "activeCompany",
                          },
                        },
                        _vm._l(_vm.userCompanies, function (entity, index) {
                          return _c(
                            "v-list-item",
                            {
                              key: entity.company.id,
                              on: {
                                click: function ($event) {
                                  return _vm.setActiveEntity(
                                    entity,
                                    "COMPANY",
                                    index
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(entity.company.name)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userCompanies.length
                    ? _c("v-divider", { staticClass: "my-3" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userShops.length
                    ? _c("v-subheader", { staticClass: "primary--text" }, [
                        _vm._v("SHOPS"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userShops
                    ? _c(
                        "v-list-item-group",
                        {
                          attrs: { mandatory: "", color: "primary" },
                          model: {
                            value: _vm.activeShop,
                            callback: function ($$v) {
                              _vm.activeShop = $$v
                            },
                            expression: "activeShop",
                          },
                        },
                        _vm._l(_vm.userShops, function (entity, index) {
                          return _c(
                            "v-list-item",
                            {
                              key: entity.shop.id,
                              on: {
                                click: function ($event) {
                                  return _vm.setActiveEntity(
                                    entity,
                                    "SHOP",
                                    index
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(entity.shop.name)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userShops.length
                    ? _c("v-divider", { staticClass: "my-3" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-center align-end fixed-bottom",
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "font-weight-bold",
                          attrs: { color: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialog = true
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("global.menu.account.logout")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "280" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "px-7 py-8" },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "p-0 pb-3 text-h5",
                  staticStyle: { "border-bottom": "1px solid #1890ff" },
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("home.widgets.signout.title"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                {
                  staticClass: "p-0 mt-4 mb-8",
                  staticStyle: {
                    "font-size": "14px",
                    "line-height": "24px",
                    color: "#141414",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("home.widgets.signout.message")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "px-0 justify-content-end" },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { "font-size": "12px" },
                      attrs: {
                        "min-width": "71",
                        color: "secondary",
                        rounded: "",
                        outlined: "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("home.widgets.signout.cancel"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-4 text-uppercase",
                      staticStyle: { "font-size": "12px" },
                      attrs: {
                        "min-width": "71",
                        color: "primary",
                        rounded: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.logout()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("home.widgets.signout.yes")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }